import React from 'react';
import PolicyImpactTool from '../tools/PolicyImpactTool';
import { useLocation } from '../../contexts/LocationContext';
import { PageHeader } from '../layout/PageHeader';

export const PolicyTool: React.FC = () => {
  const { selectedLocation, selectedGeofips, coreDataLoading } = useLocation();

  if (coreDataLoading) {
    return (
      <div>
        <PageHeader
          title="GHG Policy Impact Tool (Under development)"
          variant="maps"
        />
        <div className="page-container">
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading core data for {selectedLocation}...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <PageHeader
        title="GHG Policy Impact Tool (Under development)"
        variant="maps" // reuse the purple header styling
      />

      <div className="page-container">
        <PolicyImpactTool location={selectedLocation} geofips={selectedGeofips} />
      </div>
    </div>
  );
};
